export const EVENT_EXPERIMENT_VIEWED = 'experiment_viewed';
export const EVENT_PROMO_GIFTCARD_CLAIMED = 'promo_giftcard_claimed';
export const EVENT_DEPOSIT_MODAL_OPENED = 'deposit_modal_opened';
export const EVENT_WITHDRAW_MODAL_OPENED = 'withdraw_modal_opened';
export const EVENT_DEPOSIT_OPTION_CLICKED = 'deposit_option_clicked';
export const EVENT_WITHDRAW_OPTION_CLICKED = 'withdraw_option_clicked';
export const EVENT_VIEW_TOKEN_BUY = 'view_token_buy';
export const EVENT_VIEW_TOKEN_SELL = 'view_token_sell';
export const EVENT_SWAP_INPUT_CHANGED = 'swap_input_changed';
export const EVENT_TOKEN_SWAP = 'token_swap';
export const EVENT_PHYSICAL_GIFT_CARD_ATTEMPT = 'physical_gift_card_attempt';
export const EVENT_LOGIN_BUTTON_CLICKED = 'login_button_clicked';
export const EVENT_PLAY_STORE_BUTTON_CLICKED = 'play_store_button_clicked';
export const EVENT_APP_STORE_BUTTON_CLICKED = 'app_store_button_clicked';
export const EVENT_GIFT_FLOW_STARTED = 'gift_flow_started';
export const EVENT_GIFT_FLOW_TOKEN_SELECTED = 'gift_flow_token_selected';
export const EVENT_GIFT_FLOW_PREVIUS_IMAGE_SELECTED =
  'gift_flow_previous_image_selected';
export const EVENT_GIFT_FLOW_NEXT_IMAGE_SELECTED =
  'gift_flow_next_image_selected';
export const EVENT_GIFT_FLOW_IMAGE_SELECTED = 'gift_flow_image_selected';
export const EVENT_GIFT_FLOW_CUSTOM_IMAGE_DELETED =
  'gift_flow_custom_image_deleted';
export const EVENT_GIFT_FLOW_CUSTOM_IMAGE_CREATED =
  'gift_flow_custom_image_created';
export const EVENT_GIFT_FLOW_DIGITAL_SELECTED = 'gift_flow_digital_selected';
export const EVENT_GIFT_FLOW_PHYSICAL_SELECTED = 'gift_flow_physical_selected';
export const EVENT_GIFT_FLOW_DELIVERY_COMPLETED =
  'gift_flow_delivery_completed';
export const EVENT_GIFT_FLOW_PREVIEW_COMPLETED = 'gift_flow_preview_completed';
export const EVENT_GIFT_FLOW_MESSAGE_CHANGED = 'gift_flow_message_changed';
export const EVENT_GIFT_FLOW_CUSTOMIZATION_COMPLETED =
  'gift_flow_customization_completed';
export const EVENT_GIFT_FLOW_PRICE_BUTTON_CLICKED =
  'gift_flow_price_button_clicked';
export const EVENT_GIFT_FLOW_PRICE_CHANGED = 'gift_flow_price_changed';
export const EVENT_GIFT_FLOW_PRICE_SELECTION_COMPLETED =
  'gift_flow_price_selection_completed';
export const EVENT_GIFT_FLOW_SENDER_NAME_CHANGED =
  'gift_flow_sender_name_changed';
export const EVENT_GIFT_FLOW_SENDER_EMAIL_CHANGED =
  'gift_flow_sender_email_changed';
export const EVENT_GIFT_FLOW_SENDER_CODE_SENT = 'gift_flow_sender_code_sent';
export const EVENT_GIFT_FLOW_SENDER_CODE_VERIFIED =
  'gift_flow_sender_code_verified';
export const EVENT_GIFT_FLOW_SENDER_CODE_FAILED =
  'gift_flow_sender_code_failed';
export const EVENT_GIFT_FLOW_SHIPPING_RECIPIENT_NAME_CHANGED =
  'gift_flow_shipping_recipient_name_changed';
export const EVENT_GIFT_FLOW_SHIPPING_ADDRESS_CHANGED =
  'gift_flow_shipping_address_changed';
export const EVENT_GIFT_FLOW_SHIPPING_DETAILS_COMPLETED =
  'gift_flow_shipping_details_completed';
export const EVENT_GIFT_FLOW_PAYMENT_METHOD_SELECTOR_OPENED =
  'gift_flow_payment_method_selector_opened';
export const EVENT_GIFT_FLOW_PAYMENT_METHOD_SELECTED =
  'gift_flow_payment_method_selected';
export const EVENT_GIFT_FLOW_APPLE_PAY_BUTTON_CLICKED =
  'gift_flow_apple_pay_button_clicked';
export const EVENT_GIFT_FLOW_CREATE_GIFT_BUTTON_CLICKED =
  'gift_flow_create_gift_button_clicked';
export const EVENT_GIFT_FLOW_GIFT_CREATED = 'gift_flow_gift_created';
export const EVENT_GIFT_FLOW_GIFT_FAILED = 'gift_flow_gift_failed';
export const EVENT_FREE_GIFT_FLOW_SHOWN = 'free_gift_flow_shown';
export const EVENT_CHECKOUT_VIEWED = 'checkout_viewed';
export const EVENT_CHECKOUT_AMOUNT_CHANGED = 'checkout_amount_changed';
export const EVENT_CHECKOUT_SENDER_NAME_ADDED = 'checkout_sender_name_added';
export const EVENT_CHECKOUT_MESSAGE_ADDED = 'checkout_message_added';
export const EVENT_CHECKOUT_APPLE_PAY_CLICKED = 'checkout_apple_pay_clicked';
export const EVENT_APPLE_LOGIN_CLICKED = 'apple_login_clicked';
export const EVENT_CHECKOUT_COINBASE_APPLE_PAY_IFRAME_CLICKED =
  'checkout_coinbase_apple_pay_iframe_clicked';
export const EVENT_CHECKOUT_APPLE_PAY_DEPOSIT_SUCCESS =
  'checkout_apple_pay_deposit_success';
export const EVENT_CHECKOUT_GIFT_CREATED = 'checkout_gift_created';
export const EVENT_VERIFY_PHONE_NUMBER_MODAL_SHOWN =
  'verify_phone_number_modal_shown';
export const EVENT_PHONE_VERIFIED = 'phone_verified';

// Spend/Gift Card events
export const EVENT_SPEND_GALLERY_OPENED_FROM_LANDING_PAGE =
  'spend_gallery_opened_from_landing_page';
export const EVENT_SPEND_ITEM_OPENED_FROM_LANDING_PAGE =
  'spend_item_opened_from_landing_page';
export const EVENT_SPEND_GALLERY_CARD_CLICKED = 'spend_gallery_card_clicked';
export const EVENT_SPEND_DETAIL_AMOUNT_CHANGED = 'spend_detail_amount_changed';
export const EVENT_SPEND_DETAIL_BUY_BUTTON_CLICKED =
  'spend_detail_buy_button_clicked';
export const EVENT_SPEND_CHECKOUT_PAYMENT_TOKEN_CHANGED =
  'spend_checkout_payment_token_changed';
export const EVENT_SPEND_CHECKOUT_PURCHASE_BUTTON_CLICKED =
  'spend_checkout_purchase_button_clicked';
export const EVENT_SPEND_CHECKOUT_PURCHASE_COMPLETED =
  'spend_checkout_purchase_completed';
export const EVENT_SPEND_CHECKOUT_PURCHASE_FAILED =
  'spend_checkout_purchase_failed';

export const BREAKPOINT_BANNER_CLICKED = 'breakpoint_banner_clicked';
export const BREAKPOINT_BANNER_CREATE_GIFT_CLICKED =
  'breakpoint_create_gift_clicked';
export const BREAKPOINT_BANNER_MAYBE_LATER_CLICKED =
  'breakpoint_maybe_later_clicked';
export const BREAKPOINT_GIFT_CLAIMED_VIEWED = 'breakpoint_gift_claimed_viewed';
export const BREAKPOINT_GIFT_CLAIMED_CREATE_GIFT_CLICKED =
  'breakpoint_gift_claimed_create_gift_clicked';
export const BREAKPOINT_GIFT_CLAIMED_MAYBE_LATER_CLICKED =
  'breakpoint_gift_claimed_maybe_later_clicked';

export const VARIANT_A = 'variant-a';
export const VARIANT_B = 'variant-b';

export const BRIDGE = 'bridge';
export const STRIPE = 'stripe';
export const COINBASE = 'coinbase';
export const WEB3_WALLET = 'web3_wallet';
export const APPLE_PAY = 'apple_pay';

// Apple Pay funnel (shared by gift and deposit flows)
export const EVENT_APPLE_PAY_LINK_REQUESTED = 'apple_pay_link_requested';
export const EVENT_APPLE_PAY_LINK_CREATED = 'apple_pay_link_created';
export const EVENT_APPLE_PAY_LINK_FAILED = 'apple_pay_link_failed';
export const EVENT_APPLE_PAY_PAYMENT_COMPLETED = 'apple_pay_payment_completed';
export const EVENT_APPLE_PAY_PAYMENT_CANCELLED = 'apple_pay_payment_cancelled';
export const EVENT_APPLE_PAY_PAYMENT_FAILED = 'apple_pay_payment_failed';

export const NAVBAR = 'navbar';
export const TOKEN = 'token';
export const DASHBOARD = 'dashboard';

export const EXPERIMENT_NAME_EARN_REWARDS_DASHBOARD = 'earn_rewards_dashboard';

export let featureFlags = {};

export const setFeatureFlags = (flags) => {
  featureFlags = flags;
};

// Twitter event ID mapping
const TWITTER_EVENT_ID_MAP = {
  [EVENT_GIFT_FLOW_STARTED]: 'tw-q4iz5-qvgjx',
  [EVENT_GIFT_FLOW_CUSTOMIZATION_COMPLETED]: 'tw-q4iz5-qvgix',
  [EVENT_GIFT_FLOW_GIFT_CREATED]: 'tw-q4iz5-qvgir',
};

/** Sends a Meta Pixel standard event via fbq('track', eventName, parameters). */
export const sendMetaEvent = (eventName, parameters = {}) => {
  if (import.meta.env.DEV) return;
  try {
    fbq('track', eventName, parameters);
  } catch (error) {
    console.error('Error sending Meta event', error);
  }
};

export const sendEvent = (eventName, parameters = {}) => {
  if (!import.meta.env.DEV) {
    try {
      gtag('event', eventName, { ...parameters, ...featureFlags });
    } catch (error) {
      console.error('Error sending event', error);
    }

    try {
      fbq('trackCustom', eventName, { ...parameters, ...featureFlags });
    } catch (error) {
      console.error('Error sending Facebook Pixel event', error);
    }

    try {
      // Only send Twitter events if we have a mapped event ID
      const twitterEventId = TWITTER_EVENT_ID_MAP[eventName];

      if (twitterEventId) {
        twq('event', twitterEventId);
      }
    } catch (error) {
      console.error('Error sending Twitter event', error);
    }
  } else {
    console.log('Sending event', eventName, parameters);
  }
};

export const sendExperimentResult = (experimentName, variant) => {
  sendEvent(EVENT_EXPERIMENT_VIEWED, {
    experiment_name: experimentName,
    variant,
  });
};
